// ─────────────────────────────────────────────────────────────────────────
// Single source of truth for the answer types the backend actually supports.
// IMPORTANT: only SINGLE_CHOICE, MULTI_CHOICE and RATING exist in the data
// model / API contract today. Do not add types here without adding real
// backend + createDefaultOptions() support first — the visual design below
// is intentionally limited to what the product can actually save.
// ─────────────────────────────────────────────────────────────────────────

export const QUESTION_TYPES = {
  SINGLE_CHOICE: {
    value: "SINGLE_CHOICE",
    label: "Yes / No",
    shortLabel: "Y/N",
    description: "A simple binary choice",
    icon: "mdi:toggle-switch-outline",
    color: "#2563eb",
    colorSoft: "#eff6ff",
  },
  MULTI_CHOICE: {
    value: "MULTI_CHOICE",
    label: "Multiple Choice",
    shortLabel: "Choice",
    description: "Custom options you define",
    icon: "mdi:format-list-bulleted",
    color: "#7c3aed",
    colorSoft: "#f5f3ff",
  },
  RATING: {
    value: "RATING",
    label: "Rating",
    shortLabel: "1–10",
    description: "A 1–10 scale, auto-configured",
    icon: "mdi:star-outline",
    color: "#d97706",
    colorSoft: "#fffbeb",
  },
};

export const QUESTION_TYPE_LIST = Object.values(QUESTION_TYPES);

export const getQuestionTypeMeta = (value) =>
  QUESTION_TYPES[value] || QUESTION_TYPES.SINGLE_CHOICE;
